import { notify } from '../../../../utils/notification';
import apiEndpoints from '../../../api';
import axiosInstance2 from '../../../axiosInstance2'
import { logOut } from '../../../../utils/helpers/logOut'
import { errorMsg } from '../../../../consts/responseMessages';
const { detect } = require('detect-browser');
// eslint-disable-next-line no-unused-vars
const _browser = detect();


export async function societyForgotPasswordReq(action) {
    const BODY = {
        "email": action.data.email
    }

    return axiosInstance2.post(apiEndpoints.ADMIN_FORGOT_PASSWORD_API, { ...BODY })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 404) {
                notify('error', errors.response.data.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors

        })
}
export async function registerReq(action) {
    const BODY = {
        first_name: action?.data?.firstName,
        last_name: action?.data?.lastName || '',
        email: action?.data?.email,
        phone: action?.data?.phone,
        password: action?.data?.password,
    }

    return axiosInstance2.post(apiEndpoints.ADMIN_REGISTER_API, { ...BODY })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 404 || errors.response?.data.statusCode === 400) {
                notify('error', errors.response.data.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors

        })
}

export async function loginReq(action) {
    const BODY = {
        "email": action.data.email,
        "password": action.data.password,
        "login_type": "admin",
    }

    return axiosInstance2.post(apiEndpoints.ADMIN_LOGIN_API, { ...BODY })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 404 || errors.response?.data.statusCode === 400) {
                notify('error', errors.response.data.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors

        })
}
export async function logoutReq(action) {
    const BODY = {
        reason: action?.data?.reason
    }

    return axiosInstance2.post(apiEndpoints.ADMIN_LOGOUT_API, { ...BODY })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 404 || errors.response?.data.statusCode === 400) {
                notify('error', errors.response.data.message);
            }
            else if (errors.status === 403) {
                notify('error', errors.response.data.message);
                logOut();
            }
            else {
                notify('warning', "Something went wrong");
            }
            return errors

        })
}

export async function reloginReq(action) {


    return axiosInstance2.get(apiEndpoints.ADMIN_RELOGIN_API)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                if (!action.data.firstLogin || errorMsg.INVALID_ACCESS_TOKEN.includes(errors.response?.data.message)) {
                    logOut()
                } else {
                    notify('error', errors.response.data.message);
                }
            }
            else if (errors?.status === 401) {
                notify('error', errors.response.data.message);
                logOut()
            }
            else if (errors.response.data.statusCode === 404) {
                notify('error', errors.response.data.message);
                logOut()
            }
            else {
                notify('warning', "Something went wrong");
            }
            return errors

        })
}


export async function passwordResetReq(action) {
    const BODY = {
        "reset_token": action.data.token,
        "password": action.data.password,
        "confirm_password": action.data.confirmPassword
    }

    return axiosInstance2.post(apiEndpoints.ADMIN_PASSWORD_RESET_API, { ...BODY })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 400 || errors.response.data.statusCode === 404) {
                notify('error', errors.response.data.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}